//User Part

export const USER_LOADING = "USER_LOADING"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS"
export const USER_FAIL = "USER_FAIL"

//Notes data part

export const NOTES_LOADING = "NOTES_LOADING"
export const NOTES_CREATE_LOADING = "NOTES_CREATE_LOADING"
export const NOTES_UPDATE_LOADING = "NOTES_UPDATE_LOADING"
export const NOTES_GET_SUCCESS = "NOTES_GET_SUCCESS"
export const NOTES_UPDATE_SUCCESS = "NOTES_UPDATE_SUCCESS"
export const NOTES_CREATE_SUCCESS = "NOTES_CREATE_SUCCESS"
export const NOTES_DELETE_SUCCESS = "NOTES_DELETE_SUCCESS"
export const NOTES_FAIL = "NOTES_FAIL"